/**
 * Will replace {something} strings by the according value passed in 'params'
 * Example: str = 'My name is {name} and I work at {place}. My favorite game is {game}.'
 *          params = {name: 'Jorinho', place: 'Infocentric', wtf: 'nothing'}
 *          stringFormat(str, params) -> "My name is Jorinho and I work at Infocentric. My favorite game is {game}."
 *          note: the 'wtf' parameter doesn't hurt.
 *          note 2: a not provided {placeholder} will simply be ignored and returned as is...
 * @param {String} str
 * @param {Object} params
 * @returns {String}
 */
export const resolve = (str = '', params = {}) => {
  const search = /\{([\s\S]+?)\}/g

  if (!str) {
    return ''
  }

  return str.replace(search, function (term) {
    const key = term.substring(1).slice(0, -1)
    return params[key] !== undefined ? params[key] : term
  })
}
